import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ThemeProvider  from './context/ThemeContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <ThemeProvider>
    <BrowserRouter>
        <Routes>       
          <Route path="/*" element={<App />} />        
        </Routes>
    </BrowserRouter>
    </ThemeProvider>
 
);


